

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { StaticTranslationInterface, LanguageInterface } from '@/types/translations';

@Component({})
export default class TranslationBox extends Vue {
  @Prop()
  protected translation!: StaticTranslationInterface;

  @Getter('languageByID', { namespace: 'trans' })
  protected languageByID!: (arg0: number) => LanguageInterface | null;

  @Action('deleteTranslation', { namespace: 'trans' })
  protected deleteTranslation!: (arg0: StaticTranslationInterface) => Promise<void>;

  protected language: LanguageInterface | null = null;

  protected editModus: boolean = false;

  protected mounted() {
    this.language = this.languageByID(this.translation.language_id);
  }

  protected toggleEdit(): void {
    this.editModus = !this.editModus;
  }
}
